/* ==========================================================================
   VIPER EDGE USA :: Bulk order list
   File: assets/vef-bulk-list.js

   A shopper picks blades on product pages, the picks are kept in the browser
   under localStorage key vefBulkList, and they travel with the wholesale
   inquiry form as one hidden field called contact[Selected Models].

   Nothing here touches the cart, the checkout or any Shopify state. If
   localStorage is blocked the whole thing quietly does nothing and every
   other part of the page carries on as normal.
   ========================================================================== */

(function () {
  'use strict';

  if (window.vefBulkListReady) return;
  window.vefBulkListReady = true;

  var KEY = 'vefBulkList';
  var MAX_ITEMS = 60;
  var MAX_QTY = 9999;

  /* ---------------------------------------------------------------- store */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      var clean = [];
      for (var i = 0; i < parsed.length; i++) {
        var row = parsed[i];
        if (!row || typeof row !== 'object') continue;
        if (!row.id || !row.title) continue;
        clean.push({
          id: String(row.id),
          title: String(row.title),
          sku: row.sku ? String(row.sku) : '',
          url: row.url ? String(row.url) : '',
          qty: normaliseQty(row.qty),
        });
        if (clean.length >= MAX_ITEMS) break;
      }
      return clean;
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (error) {
      /* storage full or blocked, the page carries on */
    }
  }

  function clearStore() {
    try {
      window.localStorage.removeItem(KEY);
    } catch (error) {
      /* no op */
    }
  }

  function normaliseQty(value) {
    var n = parseInt(value, 10);
    if (!isFinite(n) || n < 1) n = 1;
    if (n > MAX_QTY) n = MAX_QTY;
    return n;
  }

  function indexOfId(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === String(id)) return i;
    }
    return -1;
  }

  function totalCount(items) {
    return items.length;
  }

  /* -------------------------------------------------------- product button */

  function labelFor(button, inList) {
    var label = button.querySelector('[data-vef-bulk-add-label]');
    if (!label) return;
    label.textContent = inList ? 'Remove from bulk order' : 'Add to bulk order';
  }

  function syncButtons(items) {
    var buttons = document.querySelectorAll('[data-vef-bulk-add]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var inList = indexOfId(items, button.getAttribute('data-vef-id')) > -1;
      button.setAttribute('data-vef-in-list', inList ? 'true' : 'false');
      button.setAttribute('aria-pressed', inList ? 'true' : 'false');
      labelFor(button, inList);
    }
  }

  function quantityFor(button) {
    try {
      var form = button.closest('form');
      if (!form) return 1;
      var input = form.querySelector('input[name="quantity"]');
      if (!input) return 1;
      return normaliseQty(input.value);
    } catch (error) {
      return 1;
    }
  }

  function toggleFromButton(button) {
    var items = read();
    var id = button.getAttribute('data-vef-id');
    if (!id) return;

    var at = indexOfId(items, id);

    if (at > -1) {
      items.splice(at, 1);
    } else {
      if (items.length >= MAX_ITEMS) return;
      items.push({
        id: String(id),
        title: button.getAttribute('data-vef-title') || '',
        sku: button.getAttribute('data-vef-sku') || '',
        url: button.getAttribute('data-vef-url') || '',
        qty: quantityFor(button),
      });
    }

    write(items);
    paintAll(items);
  }

  /* ------------------------------------------------------------------ pill */

  function syncPill(items) {
    var pill = document.querySelector('[data-vef-bulk-pill]');
    if (!pill) return;
    var count = totalCount(items);
    var number = pill.querySelector('[data-vef-bulk-count]');
    if (number) number.textContent = String(count);
    pill.hidden = count === 0;
  }

  /* ----------------------------------------------------------------- panel */

  function lineFor(item) {
    var parts = [item.title];
    if (item.sku) parts.push('SKU ' + item.sku);
    parts.push('qty ' + item.qty);
    if (item.url) parts.push(item.url);
    return parts.join(' | ');
  }

  function syncHiddenField(items) {
    var field = document.querySelector('[data-vef-bulk-field]');
    if (!field) return;
    var lines = [];
    for (var i = 0; i < items.length; i++) {
      lines.push(lineFor(items[i]));
    }
    field.value = lines.join('\n');
  }

  function buildRow(item) {
    var li = document.createElement('li');
    li.className = 'vef-bulk-item';
    li.setAttribute('data-vef-bulk-row', item.id);

    var main = document.createElement('div');
    main.className = 'vef-bulk-item__main';

    var title;
    if (item.url) {
      title = document.createElement('a');
      title.setAttribute('href', item.url);
    } else {
      title = document.createElement('span');
    }
    title.className = 'vef-bulk-item__title';
    title.textContent = item.title;
    main.appendChild(title);

    if (item.sku) {
      var sku = document.createElement('span');
      sku.className = 'vef-bulk-item__sku';
      sku.textContent = 'SKU ' + item.sku;
      main.appendChild(sku);
    }

    li.appendChild(main);

    var qtyWrap = document.createElement('label');
    qtyWrap.className = 'vef-bulk-item__qty';
    qtyWrap.appendChild(document.createTextNode('Qty'));

    var qtyInput = document.createElement('input');
    qtyInput.setAttribute('type', 'number');
    qtyInput.setAttribute('min', '1');
    qtyInput.setAttribute('step', '1');
    qtyInput.setAttribute('inputmode', 'numeric');
    qtyInput.setAttribute('data-vef-bulk-qty', item.id);
    qtyInput.value = String(item.qty);
    qtyWrap.appendChild(qtyInput);
    li.appendChild(qtyWrap);

    var remove = document.createElement('button');
    remove.setAttribute('type', 'button');
    remove.className = 'vef-bulk-item__remove';
    remove.setAttribute('data-vef-bulk-remove', item.id);
    remove.textContent = 'Take it off';
    li.appendChild(remove);

    return li;
  }

  function syncPanel(items) {
    var panel = document.querySelector('[data-vef-bulk-panel]');
    if (!panel) return;

    var list = panel.querySelector('[data-vef-bulk-items]');
    var empty = panel.querySelector('[data-vef-bulk-empty]');
    var note = panel.querySelector('[data-vef-bulk-note]');
    var head = panel.querySelector('[data-vef-bulk-head]');

    if (!list) return;

    while (list.firstChild) {
      list.removeChild(list.firstChild);
    }

    for (var i = 0; i < items.length; i++) {
      list.appendChild(buildRow(items[i]));
    }

    var isEmpty = items.length === 0;
    if (empty) empty.hidden = !isEmpty;
    if (note) note.hidden = isEmpty;
    if (head) head.hidden = isEmpty;
  }

  /* ------------------------------------------------------------------ paint */

  function paintAll(items) {
    var current = items || read();
    syncButtons(current);
    syncPill(current);
    syncPanel(current);
    syncHiddenField(current);
  }

  /* ----------------------------------------------------------------- events */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var addButton = target.closest('[data-vef-bulk-add]');
    if (addButton) {
      event.preventDefault();
      toggleFromButton(addButton);
      return;
    }

    var removeButton = target.closest('[data-vef-bulk-remove]');
    if (removeButton) {
      event.preventDefault();
      var items = read();
      var at = indexOfId(items, removeButton.getAttribute('data-vef-bulk-remove'));
      if (at > -1) {
        items.splice(at, 1);
        write(items);
        paintAll(items);
      }
      return;
    }

    var clearButton = target.closest('[data-vef-bulk-clear]');
    if (clearButton) {
      event.preventDefault();
      clearStore();
      paintAll([]);
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.getAttribute) return;
    var id = target.getAttribute('data-vef-bulk-qty');
    if (!id) return;

    var items = read();
    var at = indexOfId(items, id);
    if (at === -1) return;

    items[at].qty = normaliseQty(target.value);
    target.value = String(items[at].qty);
    write(items);
    syncHiddenField(items);
  });

  /* Another tab changed the list. Keep this one honest. */
  window.addEventListener('storage', function (event) {
    if (event && event.key && event.key !== KEY) return;
    paintAll();
  });

  /* Horizon morphs product markup on a variant change and on section reload,
     so new buttons appear without a page load. Relabel them when they do. */
  function watchForNewButtons() {
    if (!window.MutationObserver) return;
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        var items = read();
        syncButtons(items);
        syncPanel(items);
        syncHiddenField(items);
      }, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    var panel = document.querySelector('[data-vef-bulk-panel]');

    /* The inquiry went through, so the picks have done their job. */
    if (panel && panel.getAttribute('data-vef-bulk-submitted') === 'true') {
      clearStore();
    }

    paintAll();
    watchForNewButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
